export default __webpack_public_path__ + "static/media/edit_icon.68a50ad7.svg";